import { render } from "./Draggable.vue?vue&type=template&id=d63f0436"
import script from "./Draggable.vue?vue&type=script&lang=js"
export * from "./Draggable.vue?vue&type=script&lang=js"

import "./Draggable.vue?vue&type=style&index=0&id=d63f0436&lang=css"
script.render = render

export default script